import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$')({
  component: NotFound,
});

function NotFound() {
  return (
    <div style={{
      display: 'block',
      margin: '100px auto',
      maxWidth: '320px',
      textAlign: 'center',
    }}>
      <h1 style={{
        fontSize: '40px',
        fontWeight: 500,
        marginBottom: '10px',
      }}>
        404
        <div style={{
          fontSize: '20px',
          fontWeight: 500,
          marginBottom: '30px',
        }}>
          <span role="img" aria-label="Coffee Not Found">☕️</span> NOT FOUND
        </div>
      </h1>
      <p>
        It's too early, I need my coffee.
        <br /><br />
        <a href="https://about.coffee">
          Let's start over.
        </a>
      </p>
    </div>
  );
}
